import React, { useState, useEffect, useRef } from 'react';
import {
    Row, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import queryString from 'query-string';
import FeeTable from './FeeTable';
import FeeCard from './FeeCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faPause } from '@fortawesome/free-solid-svg-icons';
import { getFees, getDivisions, deleteFee } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function Fees(props) {
    //const queryStringParams = queryString.parse(props.location.search);
    //queryStringParams.divisions = JSON.parse(queryStringParams.divisions || []);
    //console.log(queryStringParams);

    const [layout, setLayout] = useState(localStorage.feeSearchLayout || 'card');
    const [searchOptions, setSearchOptions] = useState({ paid: 0 });
    const [fees, setFees] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(true);
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    useEffect(() => {
        fetchDivisions();
    }, []);

    //Automatically search when a search option updates (at most evry 500ms).
    useEffect(() => {
        //localStorage.setItem('feeSearchOptions', JSON.stringify(searchOptions));
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const fetchDivisions = async () => {
        setIsLoadingDivisions(true);

        setDivisions(await getDivisions());

        setIsLoadingDivisions(false);
    };

    const search = async () => {
        //Call API
        setIsLoading(true);
        //const searchMinDate = new Date(searchOptionsRef.current.minDueDate);
        //const searchMaxDate = new Date(searchOptionsRef.current.maxDueDate);
        //const searchResults = store.fees.filter(f => {
        //    f.account = store.accounts.find(o => o.id = f.accountId)
        //    return (!searchOptionsRef.current.accountNumber || f.account.accountNumber.toLowerCase() == searchOptionsRef.current.accountNumber.toLowerCase())
        //        && (!searchOptionsRef.current.account || f.account.name.toLowerCase().includes(searchOptionsRef.current.account.toLowerCase()))
        //        && (!searchOptionsRef.current.contact || (f.account.contactFirst.toLowerCase() + ' ' + f.account.contactLast.toLowerCase()).includes(searchOptionsRef.current.contact.toLowerCase()))
        //        && (!searchOptionsRef.current.divisions || searchOptionsRef.current.divisions.length === 0 || (searchOptionsRef.current.divisions.includes(f.divisionId)))
        //        && (searchOptionsRef.current.paid == -1 || (searchOptionsRef.current.paid == 1 && f.paidInFull) || (searchOptionsRef.current.paid == 0 && !f.paidInFull))
        //        && (!searchOptionsRef.current.facility || f.facility.toLowerCase().includes(searchOptionsRef.current.facility.toLowerCase()))
        //        && (!searchOptionsRef.current.minDueDate || searchMinDate <= f.dueDate)
        //        && (!searchOptionsRef.current.maxDueDate || searchMaxDate >= f.dueDate);
        //});
        //setFees(searchResults);

        const searchResults = await getFees(searchOptionsRef.current);
        setFees(searchResults);

        setIsLoading(false);
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };
    const updateMultipleSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: [...e.target.selectedOptions].map(o => Number(o.value))
        });
        //console.log(e.target.selectedOptions.map(o => o.value));
    };

    const deleteFeeRecord = async (feeId) => {
        if (await deleteFee(feeId))
            search();
        else
            console.log('Unable to delete this record.');
    };

    const toggleLayout = (type) => {
        localStorage.feeSearchLayout = type;
        setLayout(type);
    };

    const layoutJSX = layout === 'card' ? (
        <div className="action-icon tooltip-parent" onClick={() => toggleLayout('table')}>
            <FontAwesomeIcon icon={faTable} />
            <div className="tooltip-target">
                Table View
            </div>
        </div>
    ) : (
        <div className="action-icon tooltip-parent" onClick={() => toggleLayout('card')}>
            <FontAwesomeIcon icon={faPause} rotation={90} />
            <div className="tooltip-target">
                Card View
            </div>
        </div>
    );

    const feeTableOptions = {
        actions: {
            add: false,
            delete: true,
            view: true,
            edit: true,
            viewAccount: true
        },
        accountId: 0
    };

    let feesJSX = (<div>No Fees Found...</div>);
    if (isLoading) {
        feesJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>);
    } else if (fees.length > 0) {
        if (layout === 'card')
            feesJSX = fees.map(f => (<FeeCard fee={f} key={f.feeID} deleteRecord={async () => await deleteFeeRecord(f.feeID)} />));
        else
            feesJSX = (<FeeTable fees={fees} options={feeTableOptions} deleteRecord={deleteFeeRecord} />);
    }

    return (
        <div id="fees">
            <Row className="title-row">
                <Col>
                    <h1>Fees</h1>
                </Col>
            </Row>
            <Row className="search-row">
                <Col>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" name="divisionIds" value={searchOptions.divisionIds} onChange={updateMultipleSearch} multiple>
                                        {divisions.map(d => (<option value={d.divisionID} key={d.divisionID}>{d.divisionName}</option>))}
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-city"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account" name="account" value={searchOptions.account || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-user"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Contact" name="contact" value={searchOptions.contact || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-asterisk"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account Number" name="accountNumber" value={searchOptions.accountNumber || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-industry"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Facility" name="facility" value={searchOptions.facility || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-hashtag"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="EPA ID/Permit Number" name="identifier" value={searchOptions.identifier || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup className="tooltip-parent">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-calendar-alt"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="date" placeholder="Min Due Date" name="minDueDate" value={searchOptions.minDueDate || ''} onChange={updateSearch} />
                                    <div className="tooltip-target tooltip-top">
                                        Min Date
                                    </div>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup className="tooltip-parent">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-calendar-alt"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="date" placeholder="Max Due Date" name="maxDueDate" value={searchOptions.maxDueDate || ''} onChange={updateSearch} />
                                    <div className="tooltip-target tooltip-top">
                                        Max Date
                                    </div>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup className="tooltip-parent">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-check-square"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" name="paid" value={searchOptions.paid} onChange={updateSearch}>
                                        <option value={0}>Unpaid</option>
                                        <option value={1}>Paid</option>
                                        <option value={-1}>Any</option>
                                    </Input>
                                    <div className="tooltip-target tooltip-top">
                                        Paid In Full
                                    </div>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col className="col" md={{ span: 6, offset: 6 }} lg={{ span: 4, offset: 8 }} xl={{ span: 3, offset: 9 }}>
                            <Button className="btn-block btn-icon" color="danr-green" onClick={search}><i className="fas fa-search"></i><span>Search</span></Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="actions-row">
                <Col>
                    <div className="search-actions">
                        {layoutJSX}
                    </div>
                </Col>
            </Row>
            <Row className="results-row">
                <Col>
                    {feesJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Fees;